<template>
  <section id="country-tab-featured-tours" class="wrapper-tab-featured-tours">
    <h2 class="subtitle-content">{{
      $t(`${base}.title`, { name: country.name })
    }}</h2>
    <LadSearchTagsFilters />

    <LadSearchExperiencesOutlet :items="items" :is-custom="true" />

    <LadSearchShowAllTours :value="country.permalink" />
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchTabFeaturedTours',
  components: {
    LadSearchExperiencesOutlet: () =>
      import(
        /* webpackChunkName: "lad-search-experiences-outlet" */ '@/components/pages/search/partials/experiences-outlet'
      ),
    LadSearchTagsFilters: () =>
      import(
        /* webpackChunkName: "lad-search-tags-filters" */ '@/components/pages/search/country/partials/tags-filters'
      ),
    LadSearchShowAllTours: () =>
      import(
        /* webpackChunkName: "lad-search-show-all-tours" */ '@/components/pages/search/country/partials/show-all-tours'
      ),
  },
  data() {
    return {
      base: 'search.country.featured_tours',
      durations: [7, 15, 21],
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({
        name: state.header.name,
        permalink: state.header.permalink.default,
      }),
      items: 'featured',
    }),
  },
}
</script>

<style lang="scss">
section.wrapper-tab-featured-tours {
  /** */
}
</style>
